const initState = {
  authError: "",
  uid: "",
  requested: false,
  registered: false,
  user: null,
  loading: false,
  passwordLoading: false,
  isManager: false,
  needsVerification: false,
};
const authReducer = (state = initState, action) => {
  switch (action.type) {
    case "EDIT_USERS":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
        isManager:
          (action.payload.isManager && 
           (action.payload.managerCertified || action.payload.certifiedFromExternalPlatform)) ||
          false,
      };
    case "SWITCH_LAYOUT":
      return {
        ...state,
        isManager: action.payload ? (state.user?.isManager && (state.user?.managerCertified || state.user?.certifiedFromExternalPlatform)) : false,
      };
    case "REGISTER_SUCCESS":
      return {
        ...state,
        authError: "",
        registered: true,
        needsVerification: action.payload?.needsVerification || false,
      };
    case "REGISTER_FAIL":
      return {
        ...state,
      };
    case "REGISTER_COMPLETE":
      return {
        ...state,
        registered: false,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        uid: action.user.id,
        user: { ...action.user },
        isManager: 
          (action.user.isManager && 
           (action.user.managerCertified || action.user.certifiedFromExternalPlatform)) || 
          false,
        authError: "",
        needsVerification: false,
      };
    case "UPDATE_USER_DEVICE_TOKEN":
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case "LOGIN_FAIL":
      localStorage.clear();
      return {
        ...state,
        uid: "",
        authError: action.error.message,
      };
    case "LOGOUT_SUCCESS":
      return {
        ...state,
        authError: "",
        uid: "",
        registered: false,
        user: null,
        needsVerification: false,
      };
    case "ACTION_REQUEST":
      return {
        ...state,
        requested: true,
      };
    case "ACTION_REQUEST_END":
      return {
        ...state,
        requested: false,
      };
    case "LOGIN_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "LOGIN_REQUEST_END":
      return {
        ...state,
        loading: false,
      };
    case "ACTION_FORGET_REQUEST":
      return {
        ...state,
        passwordLoading: true,
      };
    case "ACTION_FORGET_REQUEST_END":
      return {
        ...state,
        passwordLoading: false,
      };
    case "PASSWORD_REQUEST":
      return {
        ...state,
        passwordLoading: true,
      };
    case "PASSWORD_REQUEST_END":
      return {
        ...state,
        passwordLoading: false,
      };
    case "PIZZA_MONEY_EMAIL":
      return {
        ...state,
        user: {
          ...state.user,
          pizzaMoneyEmail: action.payload,
        },
      };
    case "FAN_CRYPTO":
      return {
        ...state,
        user: {
          ...state.user,
          fanOpt: action.payload,
        },
      };

    case "MANAGER_CRYPTO":
      return {
        ...state,
        user: {
          ...state.user,
          managerOptIn: action.payload,
        },
      };

    case "SET_UNVERIFIED_USER":
      return {
        ...state,
        uid: action.payload.uid,
        needsVerification: true,
        authError: "",
      };

    case "CLEAR_VERIFICATION_STATE":
      return {
        ...state,
        needsVerification: false,
      };

    default:
      return {
        ...state,
      };
  }
};
export default authReducer;
